import React, { useState } from "react";
import { Back, Containter, Title } from "./SectionWeather.styled";
import Search from "./weather/search/Search";
import Forecast from "./weather/forecast/Forecast";
import CurrentWeather from "./weather/current-weather/CurrentWeather";
// import WeatherMap from "./weather/weather-map/WeatherMap";
import { WEATHER_API_KEY, WEATHER_API_URL,
  //  WEATHER_MAP_API_URL
   } from "../api";

const SectionWeather = () => {
  const [currentWeather, setCurrentWeather] = useState(null);
  // const [currentWeatherMap, setCurrentWeatherMap] = useState(null);
  const [forecast, setForecast] = useState(null);

  const handleOnSearchChange = (searchData) => {
    const [lat, lon] = searchData.value.split(" ");
    // const [lat2, lon2] = Math.round(searchData.value);

    const currentWeatherFetch = fetch(
      `${WEATHER_API_URL}/weather?lat=${lat}&lon=${lon}&appid=${WEATHER_API_KEY}&units=metric`
    );

    const forecastFetch = fetch(
      `${WEATHER_API_URL}/forecast?lat=${lat}&lon=${lon}&appid=${WEATHER_API_KEY}&units=metric`
    );

    // const currentWeatherMapFetch = fetch(
    //   `${WEATHER_MAP_API_URL}/temp_new/10/${lat2}/${lon2}.png?appid=${WEATHER_API_KEY}`
    // );

    Promise.all([currentWeatherFetch, forecastFetch,
      //  currentWeatherMapFetch
      ])
      .then(async (response) => {
        const weatherResponse = await response[0].json();
        const forcastResponse = await response[1].json();
        // const weatherMapResponse = await response[2].json();

        setCurrentWeather({ city: searchData.label, ...weatherResponse });
        setForecast({ city: searchData.label, ...forcastResponse });
        // setCurrentWeatherMap({ city: searchData.label, ...weatherMapResponse });
      })
      .catch(console.log("error"));
  };

  return (
    <Back className="weather-section" id="Weather">
      <Title>Check your City Weather</Title>
      <Containter>
        <Search onSearchChange={handleOnSearchChange} />
        {/* {currentWeatherMap && <WeatherMap data={currentWeatherMap} />} */}
        {currentWeather && <CurrentWeather data={currentWeather} />}
        {forecast && <Forecast data={forecast} />}
      </Containter>
    </Back>
  );
};

export default SectionWeather;
